<template>
  <div class="d-flex justify-content-end align-items-center w-100 flex-wrap">
    <!-- Left: info -->
    <div v-if="totalRecords > 0" class="dataTables_info text-nowrap me-auto pg-info">
      Showing 
      <span class="txt-color-darken">{{ formatNumber(startRecord) }}</span> to 
      <span class="txt-color-darken">{{ formatNumber(endRecord) }}</span> of 
      <span class="text-primary">{{ formatNumber(totalRecords) }}</span> entries
    </div>
    <!-- Right: pagination -->
<ul class="pagination pagination-sm mb-0">
  <li :class="{ disabled: currentPage <= 1 }">
    <button :disabled="currentPage <= 1" title="First page" @click="goToPage(1)">
      <i class="fa fa-angle-double-left pg-icon"></i><span class="pg-word">First</span>
    </button>
  </li>

  <li :class="{ disabled: currentPage <= 1 }">
    <button :disabled="currentPage <= 1" title="Previous page" @click="goToPage(currentPage - 1)">
      <i class="fa fa-angle-left pg-icon"></i><span class="pg-word">Prev</span>
    </button>
  </li>

  <li
  v-if="showFullPagination"
  v-for="item in pageNumbers"
    :key="item"
    :class="{ active: currentPage === item, disabled: item === '...' }"
  >
    <button
      v-if="item !== '...'"
      :disabled="currentPage === item"
      @click="goToPage(item)"
    >
      {{ formatNumber(item) }}
    </button>
    <span v-else class="pagination-ellipsis sa-core-color">…</span>
  </li>

  <li :class="{ disabled: showFullPagination ? currentPage >= totalPages : !hasNextPage }">
  <button
    :disabled="showFullPagination ? currentPage >= totalPages : !hasNextPage"
    title="Next page"
    @click="goToPage(currentPage + 1)"
  >
    <i class="fa fa-angle-right pg-icon"></i><span class="pg-word">Next</span>
  </button>
</li>

<li
  :class="{
    disabled: showFullPagination
      ? currentPage >= totalPages
      : lastKnownPage !== null && currentPage >= lastKnownPage
  }"
>
  <button
    :disabled="showFullPagination
      ? currentPage >= totalPages
      : lastKnownPage !== null && currentPage >= lastKnownPage"
    title="Last page"
    @click="showFullPagination ? goToPage(totalPages) : $emit('last-page-request')"
  >
    <i class="fa fa-angle-double-right pg-icon"></i><span class="pg-word">Last</span>
  </button>
</li>
</ul>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  emits: ['page-changed', 'loaderMessage', 'last-page-request'],
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    hasNextPage: {
      type: Boolean,
      default: false,
    },
    lastKnownPage: {
      type: Number,
      default: null,
    },
    totalRecords: {
      type: Number,
      required: true,
    },
    showFullPagination: {
      type: Boolean,
      default: true,
    },
    startRecord: {
      type: Number,
      required: true,
    },
    endRecord: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      // Phones (under 768px): short pagination (3 page numbers, icons instead of words)
      isSmall: window.matchMedia('(max-width: 767.98px)').matches,
    };
  },
  mounted() {
    this.smallQuery = window.matchMedia('(max-width: 767.98px)');
    this.onSmallChange = (e) => { this.isSmall = e.matches; };
    this.smallQuery.addEventListener('change', this.onSmallChange);
  },
  beforeUnmount() {
    this.smallQuery?.removeEventListener('change', this.onSmallChange);
  },
  computed: {
    pageNumbers() {
      const total = Math.max(0, this.totalPages);
      const current = Math.min(Math.max(1, this.currentPage), total);

      // Phones: only the current page and its neighbours (« ‹ › » reach the rest)
      if (this.isSmall) {
        const start = Math.max(1, Math.min(current - 1, total - 2));
        const end = Math.min(total, start + 2);
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
      }

      if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }

      if (current <= 3) {
        return [1, 2, 3, '...', total - 1, total];
      }

      if (current >= total - 2) {
        return [1, 2, '...', total - 2, total - 1, total];
      }

      return [1, 2, '...', current, '...', total - 1, total];
    },
  },
  methods: {
    goToPage(page) {
      this.$emit("loaderMessage",  this.$loaderMessages.loading);
      this.$emit("page-changed", page);
    },
    formatNumber(number) {
      return Number(number || 0).toLocaleString('en-US');
    },
  },
};
</script>
